<template lang="pug">
b-navbar#main-nav(toggleable='md', type='light')
  .container
    b-navbar-toggle(target='nav_collapse')
    //b-navbar-brand(href='/') FoxBooks
    b-navbar-brand(href='/') Small Business Bookkeeping
    b-collapse#nav_collapse(is-nav='')
      b-navbar-nav(v-if='!user.email')
        b-nav-item(@click='scrollTo("#how")') Features
        b-nav-item(@click='scrollTo("#pricing")') Pricing
      // Right aligned nav items
      b-navbar-nav.ml-auto
        b-nav-item(@click='toggleLogin()', v-if='!user.email') Login
        b-nav-item(@click='logout()' v-else) Logout
        .btn.btn-primary(@click='scrollTo("#register")', v-if='!user.email') Get Started
  .login(v-if='showLogin')
    h4 Login
    form
      .form-group
        label Email
        input(type='email', v-model='email')
      .form-group
        label Password
        input(type='password', v-model='password')
      button.btn.btn-primary.btn-large(@click.prevent='login()', :disabled='loading') Login
</template>

<style lang="scss" scoped>
  #main-nav {
    border-bottom: 1px solid #eee;
    position: relative;
    min-height: 80px;
    background: #fff;

    .login {
      background: #fff;
      padding: 2rem 4rem;
      position: absolute;
      right: 2rem;
      top: 80px;
      z-index: 1;

      input {
        padding: 6px 12px;
        width: 100%;
        font-size: 16px;
        line-height: 1.5;
        color: #555;
        background-color: #fff;
        background-image: none;
        border: 1px solid #e7e9ec;
        border-radius: 3px;
        -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
        box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
        -webkit-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
        -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
        transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
      }
    }
  }
</style>

<script>
import {
  login,
  register,
  isLoggedIn,
  apiLogout,
  getUser
} from '../lib/api'

export default {
  data () {
    return {
      user: {},
      showLogin: false,
      email: '',
      password: '',
      loading: false
    }
  },
  async mounted() {
    if (isLoggedIn()) {
      this.user = await getUser();
    }
  },
  methods: {
    scrollTo (id) {
      document.querySelector(id)
        .scrollIntoView({
          behavior: 'smooth'
        })
    },
    logout () {
      apiLogout()
      this.$router.push({ name: 'Home' })
    },
    toggleLogin () {
      this.showLogin = !this.showLogin
    },
    async login () {
      this.loading = true
      this.user = await login(this.email, this.password)
      this.loading = false
      this.toggleLogin()
      this.$router.push({ name: 'Account' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Nav.vue